import { useEffect } from 'react'
import LaunchAnnouncement from './components/LaunchAnnouncement'
import ScrollToTop from './components/ScrollToTop'

function App() {
  useEffect(() => {
    document.title = 'Jinkasan - La plateforme est maintenant en ligne ! 🚀'
  }, [])

  return (
    <div className="min-h-screen bg-white">
      {/* Annonce de lancement */}
      <main>
        <LaunchAnnouncement />
      </main>
        
      {/* Utilities */}
      <ScrollToTop />
    </div>
  )
}

export default App